const rewardTypes = {
    FREE_COFFEE: 'FREE_COFFEE',
    IQOS_RING: 'IQOS_RING',
    IQOS_RINGS: 'IQOS_RINGS',
    TEREA_PACK: 'TEREA_PACK',
    LEVIA_PACK: 'LEVIA_PACK',
    IQOS_DRINK: 'IQOS_DRINK',
    TEREA_LEVIA_PACK: 'TEREA_LEVIA_PACK',
};

export default rewardTypes;
